import React from 'react';
import StreakEmojiSplash from './StreakEmojiSplash';
import StreakRollingNumber from './StreakRollingNumber';
import './StreakOverlayScreen.css';

/**
 * Streak celebration overlay: streakscreen.png + rolling day count.
 */
export default function StreakOverlayScreen({
  from = 1,
  to = 1,
  fast = false,
}) {
  return (
    <div className="streak-overlay-screen">
      <StreakEmojiSplash fast={fast} />
      <img
        src={`${process.env.PUBLIC_URL}/streakscreen.png`}
        alt=""
        className="streak-overlay-screen-bg"
        draggable={false}
      />
      <div className="streak-overlay-screen-content">
        <div className="streak-overlay-screen-headline">
          <StreakRollingNumber
            from={from}
            to={to}
            fast={fast}
            rollDelayMs={fast ? 120 : 320}
          />
          <span className="streak-overlay-screen-day-label">Day</span>
        </div>
      </div>
    </div>
  );
}
